(function($) {
    $.fn.scrollTo = function() {
        return this.each(function() {
            $('body, html').scrollTop($(this).offset().top - $('div.banner.fixed-top').height());
        });
    };
}(jQuery));